/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceStoreLocation
 */
export interface SurfaceStoreLocation {
    /**
     * 
     * @type {string}
     * @memberof SurfaceStoreLocation
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStoreLocation
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStoreLocation
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStoreLocation
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStoreLocation
     */
    zipCode?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceStoreLocation
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceStoreLocation
     */
    lng?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStoreLocation
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStoreLocation
     */
    hours?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStoreLocation
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStoreLocation
     */
    category?: string;
}

/**
 * Check if a given object implements the SurfaceStoreLocation interface.
 */
export function instanceOfSurfaceStoreLocation(value: object): value is SurfaceStoreLocation {
    return true;
}

export function SurfaceStoreLocationFromJSON(json: any): SurfaceStoreLocation {
    return SurfaceStoreLocationFromJSONTyped(json, false);
}

export function SurfaceStoreLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceStoreLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'address': json['address'] == null ? undefined : json['address'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'hours': json['hours'] == null ? undefined : json['hours'],
        'url': json['url'] == null ? undefined : json['url'],
        'category': json['category'] == null ? undefined : json['category'],
    };
}

export function SurfaceStoreLocationToJSON(json: any): SurfaceStoreLocation {
    return SurfaceStoreLocationToJSONTyped(json, false);
}

export function SurfaceStoreLocationToJSONTyped(value?: SurfaceStoreLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'address': value['address'],
        'city': value['city'],
        'state': value['state'],
        'zipCode': value['zipCode'],
        'lat': value['lat'],
        'lng': value['lng'],
        'phone': value['phone'],
        'hours': value['hours'],
        'url': value['url'],
        'category': value['category'],
    };
}

